import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ToastService } from '@webapp/ui';
import { firstValueFrom } from 'rxjs';
import { UserStatusValue } from '../interfaces/users.interface';
import { UsersService } from './users.service';

/**
 * Shared orchestrator for status-change requests (users and prospects
 * flows). Owns the error→toast mapping and returns a boolean instead of
 * letting callers deal with the raw Observable/error, so both stores stay
 * in sync on behavior. See design D4.
 */
@Injectable({
	providedIn: 'root',
})
export class UserStatusService {
	private readonly service = inject(UsersService);
	private readonly toastService = inject(ToastService);

	async changeStatus(userId: string, status: UserStatusValue): Promise<boolean> {
		try {
			await firstValueFrom(this.service.changeUserStatus(userId, status));
			return true;
		} catch (error) {
			this.toastService.showToast(
				'Error',
				this.messageFor((error as HttpErrorResponse).status),
				'error'
			);
			return false;
		}
	}

	private messageFor(status: number): string {
		switch (status) {
			case 400:
				return 'No podés cambiar tu propio estado';
			case 401:
				return 'Tu sesión expiró, volvé a ingresar';
			case 403:
				return 'No tenés permisos para cambiar el estado de este usuario';
			case 404:
				return 'Usuario no encontrado';
			default:
				return 'Ocurrió un error al cambiar el estado';
		}
	}
}
